import { render, staticRenderFns } from "./Bando29Fase2.vue?vue&type=template&id=53222df0&scoped=true"
import script from "./Bando29Fase2.vue?vue&type=script&lang=js"
export * from "./Bando29Fase2.vue?vue&type=script&lang=js"
import style0 from "./Bando29Fase2.vue?vue&type=style&index=0&id=53222df0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53222df0",
  null
  
)

export default component.exports